import { useEffect, useState } from "react";
import "../../assest/index.css";
import Card from "../../component/card";
import Jobcard from "../../component/jobcard";
import Babysittercard from "../../component/babysitter";
import Eventlistcard from "../../component/Eventlistcard";
import Buysellcard from "../../component/Buysellcard";
import LocalBizcard from "../../component/LocalBizServices";
import AdsOnCard from "../../component/AdsOnCard";
import getFetchConfig from "../../utils/getFetchConfig";
import appURLs from "../../appURL";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, json, useNavigate } from "react-router-dom";
import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import getSymbolFromCurrency from "currency-symbol-map";
import moment from "moment-timezone";
import "moment-duration-format";


export default function Home({ adsId = "", latitudes, longitudes, setCount }) {
  const navigate = useNavigate();
  const fetchConfig = getFetchConfig(),
    appURL = appURLs();

  const [roomRentData, setRoomRentData] = useState([]);

  const [myJobsData, setMyJobData] = useState([]);
  const [eventsData, setEventData] = useState([]);
  const [babySitterData, setBabySitterData] = useState([]);
  const [buySellData, setBuySellData] = useState([]);
  const [localBizData, setLocalBizData] = useState([]);
  const [filterlocations, sefilterlectLocation] = useState();

  const [rentfeatureStatus, setRentFeaturedStatus] = useState(false);
  const [jobFeaturedStatus, setJobFeaturedStatus] = useState(false);
  const [eventFeaturedStatus, setEventFeaturedStatus] = useState(false);
  const [buySellFeaturedStatus, setBuySellFeaturedStatus] = useState(false);
  const [bizFeaturedStatus, setBizFeaturedStatus] = useState(false);
  const [babyFeaturedStatus, setBabyFeaturedStatus] = useState(false);

  const [recommendData, setRecommendedData] = useState([]);

  const [loader, setloader] = useState(false);
  const [adsOnData, setAdsOnData] = useState([]); // Home page gallery
  const [urgentData, setUrgentData] = useState([]);
  const [upcomingEventData, setUpcomingEventData] = useState([]);
  const [priceDropData, setPriceDropData] = useState([]);
  const [notificationCount, setNotificationCount] = useState(0);

  const [imageArray, setImageArray] = useState([]);
  const [bannerData, setBannerData] = useState([]);
  const [lat, setLat] = useState(null);
  const [lang, setLang] = useState(null);

  const latitude = localStorage.getItem("latitude");
  const longitude = localStorage.getItem("longitude");

  const responsive = {
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 4,
      slidesToSlide: 4, // This sets how many slides should be scrolled on each navigation
    },
    tablet: {
      breakpoint: { max: 1024, min: 768 },
      items: 1,
      slidesToSlide: 1,
    },
    mobile: {
      breakpoint: { max: 768, min: 0 },
      items: 1,
      slidesToSlide: 1,
    },
  };

  const geetingDataLTLNG = (lat, lang) => {
    setLang(lat);
    setLat(lang);
  };

  const handleRedirect = () => {
    // localStorage.setItem("selectedSubCategory", JSON.stringify(null));
    localStorage.removeItem("selectedSubCategory");
    localStorage.removeItem("hoveredCategory");
    localStorage.removeItem("rental_isFavorite");
    localStorage.setItem("PostType", "64e48fbcf9eeb14b6e2135c0");
    localStorage.setItem("categoryName", "Rentals");
    localStorage.setItem("subcategoryName", "View All Rentals");
    navigate("/view_for_rent");
  };

  const handleRedirectJobs = () => {
    localStorage.setItem("selectedSubCategory", JSON.stringify(null));
    //  localStorage.removeItem("selectedSubCategory");
    localStorage.removeItem("hoveredCategory");
    localStorage.removeItem("job_isFavorite");
    localStorage.setItem("PostType", "64e48fa9f9eeb14b6e2135be");
    localStorage.setItem("categoryName", "Jobs");
    localStorage.setItem("subcategoryName", "View All Jobs");
    navigate("/view_for_job");
  };

  const handleRedirectLocalBiz = () => {
    localStorage.removeItem("selectedSubCategory");
    localStorage.removeItem("hoveredCategory");
    localStorage.setItem("PostType", "64e48f89f9eeb14b6e2135ba");
    localStorage.setItem("categoryName", "Local Biz");
    localStorage.setItem("subcategoryName", "View All Local Biz");
    localStorage.removeItem("localBiz_isFavorite");
    navigate("/view_for_localBiz_and_Services");
  };

  const handleRedirectEvents = () => {
    localStorage.removeItem("selectedSubCategory");
    localStorage.removeItem("hoveredCategory");
    localStorage.setItem("PostType", "64e48f98f9eeb14b6e2135bc");
    localStorage.setItem("categoryName", "Events");
    localStorage.setItem("subcategoryName", "View All Events");
    localStorage.removeItem("event_isFavorite");
    navigate("/view_for_events");
  };
  const handleRedirectBuySell = () => {
    localStorage.setItem("selectedSubCategory", JSON.stringify(null));
    localStorage.setItem("hoveredCategory", JSON.stringify(null));
    localStorage.removeItem("buySell_isFavorite");
    navigate("/view/BuyAndSell");
  };

  const handleRedirectBabySitter = () => {
    localStorage.removeItem("selectedSubCategory");
    localStorage.removeItem("hoveredCategory");
    localStorage.setItem("categoryName", "Babysitter & Nannies");
    localStorage.setItem("subcategoryName", "View All Babysitter and Nannies");
    localStorage.removeItem("babysitter_isFavorite");
    navigate("/view_for_Babysitter_and_nannies");
  };

  const myPage = 20;

  // const fetchRoomRentData = async () => {
  //   try {
  //     // setloader(true);
  //     const token = localStorage.getItem("token");
  //     const headers = {
  //       "Content-Type": "application/json",
  //       ...(token && { Authorization: `Bearer ${token}` }),
  //     };

  //     let apiUrl = `${appURL}/posts/room-rents/fetchAds`;

  //     if (latitudes !== null && longitudes !== null) {
  //       apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
  //     }

  //     if (latitudes === null && longitudes === null) {
  //       apiUrl += `?longitude=&latitude=&maxDistance=100`;
  //     }

  //     const response = await fetch(apiUrl, {
  //       ...fetchConfig,
  //       method: "GET",
  //       headers: headers,
  //     });

  //     if (!response.ok) {
  //       throw new Error("Network response was not ok");
  //     }
  //     const jsonData = await response.json();

  //     const mergedData = [...jsonData.records];

  //     const roomRentDataWithCleanedDescriptions = mergedData
  //       .slice(0, 21)
  //       .map((record) => ({
  //         ...record,
  //         adsInfo: {
  //           ...record.adsInfo,
  //           descriptions: record.adsInfo.descriptions.replace(/<[^>]+>/g, ""), // Remove HTML tags
  //         },
  //       }));

  //     const featuredStatus = jsonData.AdOnsData.featuredData.map((record) => {
  //       const isFeatured =
  //         record.addons_validity &&
  //         record.addons_validity.some((addon) => addon.name === "Featured");

  //       return isFeatured;
  //     });

  //     setRentFeaturedStatus(featuredStatus);
  //     setRoomRentData(roomRentDataWithCleanedDescriptions);
  //     // setloader(false);
  //   } catch (error) {
  //     // setloader(false);
  //     console.error("Error fetching data:", error);
  //   }
  // };

  //****************** Jobs Data *************************** */

const fetchRoomRentData = async () => {
  try {
    const token = localStorage.getItem("token");
    const headers = {
      "Content-Type": "application/json",
      ...(token && { Authorization: `Bearer ${token}` }),
    };

    let apiUrl = `${appURL}/posts/room-rents/fetchAds`;
    if (latitudes !== null && longitudes !== null) {
      apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
    } else {
      apiUrl += `?longitude=&latitude=&maxDistance=100`;
    }

    const response = await fetch(apiUrl, { ...fetchConfig, method: "GET", headers });
    if (!response.ok) throw new Error("Network response was not ok");

    const jsonData = await response.json();
    const featuredData = jsonData.AdOnsData.featuredData || [];
    

    // Merge featured first, then regular records
    const mergedData = [...featuredData, ...jsonData.records];

    // Track which indices are truly featured
    const featuredStatus = mergedData.map((record, index) => {
      return index < featuredData.length &&
        record.addons_validity?.some((addon) => addon.name === "Featured");
    });

    const cleaned = mergedData.slice(0, 21).map((record) => ({
      ...record,
      adsInfo: {
        ...record.adsInfo,
        descriptions: record.adsInfo.descriptions.replace(/<[^>]+>/g, ""),
      },
    }));

    setRentFeaturedStatus(featuredStatus);
    setRoomRentData(cleaned);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
};
  

  const fetchJobsData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      let apiUrl = `${appURL}/posts/jobs/fetchAds`;

      if (longitudes !== null && latitudes !== null) {
        apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
      }

      if (latitudes === null && longitudes === null) {
        apiUrl += `?longitude=&latitude=&maxDistance=100`;
      }

      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      // const mergedData = [...jsonData.records];
      const featuredData = jsonData.AdOnsData.featuredData || [];
const mergedData = [...featuredData, ...jsonData.records];

      // const featuredStatus = jsonData.AdOnsData.featuredData.map((record) => {
      //   const isFeatured =
      //     record.addons_validity &&
      //     record.addons_validity.some((addon) => addon.name === "Featured");
      //   return isFeatured;
      // });
const featuredStatus = mergedData.map((_, index) => index < featuredData.length);
      setJobFeaturedStatus(featuredStatus);

      setMyJobData(mergedData.slice(0, 21));
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //****************** Events Data *************************** */

  const fetchEventsData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      let apiUrl = `${appURL}/posts/events/fetchAds`;

      if (latitudes !== null && longitudes !== null) {
        apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
      }

      if (latitudes === null && longitudes === null) {
        apiUrl += `?longitude=&latitude=&maxDistance=100`;
      }

      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();

      // const mergedData = [...jsonData.records];
      const featuredData = jsonData.AdOnsData.featuredData || [];
const mergedData = [...featuredData, ...jsonData.records];

      // const featuredStatus = jsonData.AdOnsData.featuredData.map((record) => {
      //   const isFeatured =
      //     record.addons_validity &&
      //     record.addons_validity.some((addon) => addon.name === "Featured");

      //   return isFeatured;
      // });
const featuredStatus = mergedData.map((_, index) => index < featuredData.length);
      setEventFeaturedStatus(featuredStatus);

      setEventData(mergedData.slice(0, 21));
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  //****************** BabySitter Data *************************** */

  const fetchBabySitterData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      let apiUrl = `${appURL}/posts/babysitter/fetchAds`;

      if (latitudes !== null && longitudes !== null) {
        apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
      }

      if (latitudes === null && longitudes === null) {
        apiUrl += `?longitude=&latitude=&maxDistance=100`;
      }
      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      // const mergedData = [...jsonData.records];
      const featuredData = jsonData.AdOnsData.featuredData || [];
const mergedData = [...featuredData, ...jsonData.records];

      // const featuredStatus = jsonData.AdOnsData.featuredData.map((record) => {
      //   const isFeatured =
      //     record.addons_validity &&
      //     record.addons_validity.some((addon) => addon.name === "Featured");
      //   return isFeatured;
      // });
    const featuredStatus = mergedData.map((_, index) => index < featuredData.length);
      setBabyFeaturedStatus(featuredStatus);

      setBabySitterData(mergedData.slice(0, 21));
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //****************** Buy & Sell Data *************************** */

  const fetchBuySellData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      let apiUrl = `${appURL}/posts/buysell/fetchAds`;

      if (latitudes !== null && longitudes !== null) {
        apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
      }

      if (latitudes === null && longitudes === null) {
        apiUrl += `?longitude=&latitude=&maxDistance=100`;
      }

      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      // const mergedData = [...jsonData.records];
      const featuredData = jsonData.AdOnsData.featuredData || [];
const mergedData = [...featuredData, ...jsonData.records];


      // const featuredStatus = jsonData.AdOnsData.featuredData.map((record) => {
      //   const isFeatured =
      //     record.addons_validity &&
      //     record.addons_validity.some((addon) => addon.name === "Featured");

      //   return isFeatured;
      // });
const featuredStatus = mergedData.map((_, index) => index < featuredData.length);
      setBuySellFeaturedStatus(featuredStatus);

      setBuySellData(mergedData.slice(0, 21));
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //****************** Local Biz Data *************************** */

  const fetchLocalBizData = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      let apiUrl = `${appURL}/posts/biz/fetchAds`;

      if (latitudes !== null && longitudes !== null) {
        apiUrl += `?longitude=${longitudes}&latitude=${latitudes}&maxDistance=100`;
      }

      if (latitudes === null && longitudes === null) {
        apiUrl += `?longitude=&latitude=&maxDistance=100`;
      }

      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
        headers: headers,
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();
      // const mergedData = [...jsonData.records];
      const featuredData = jsonData.AdOnsData.featuredData || [];
const mergedData = [...featuredData, ...jsonData.records];

      // const featuredStatus = jsonData.AdOnsData.featuredData.map((record) => {
      //   const isFeatured =
      //     record.addons_validity &&
      //     record.addons_validity.some((addon) => addon.name === "Featured");

      //   return isFeatured;
      // });
const featuredStatus = mergedData.map((_, index) => index < featuredData.length);
      setBizFeaturedStatus(featuredStatus);

      setLocalBizData(mergedData.slice(0, 21));
      // setData(jsonData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //****************** Recommended data api ****************************/

  const recommendedAds = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        "Content-Type": "application/json",
        ...(token && { Authorization: `Bearer ${token}` }),
      };

      const response = await fetch(
        `${appURL}/posts/ads/recomended-ads?longitude=${
          longitudes || ""
        }&latitude=${latitudes || ""}`,
        {
          ...fetchConfig,
          method: "GET",
          headers: headers,
        }
      );
      if (!response.ok) {
        throw new Error("Network response was not ok");
      }
      const jsonData = await response.json();
      setRecommendedData(jsonData.recomended_ads);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //****************** Ads On Validity api ****************************/

  const adsOnValidityData = async () => {
    try {
      let apiUrl = `${appURL}/posts/ads/adons-ads?longitude=${
        longitudes || ""
      }&latitude=${latitudes || ""}`;

      // if (lat !== null && lang !== null) {
      //   apiUrl += `?longitude=${lang}&latitude=${lat}&maxDistance=100`;
      // }

      const response = await fetch(apiUrl, {
        ...fetchConfig,
        method: "GET",
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const jsonData = await response.json();

      setNotificationCount(jsonData.unseen_total);
      setCount(jsonData.unseen_total);

      localStorage.setItem("unseen_total", jsonData.unseen_total);
      setBannerData(jsonData.banner);
      setAdsOnData(jsonData.data[0]);
      setUrgentData(jsonData.data[1]);
      setUpcomingEventData(jsonData.data[2]);
      setPriceDropData(jsonData.data[3]);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  //****************** Ads On Validity api ****************************/
  const currentDate = new Date().toISOString().split("T")[0];

  const currentDates = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const localTimeString = currentDates.toLocaleString("en-US", options);
  const formattedDateTime = `${currentDates.getFullYear()}-${(
    currentDates.getMonth() + 1
  )
    .toString()
    .padStart(2, "0")}-${currentDates
    .getDate()
    .toString()
    .padStart(2, "0")} ${currentDates
    .getHours()
    .toString()
    .padStart(2, "0")}:${currentDates
    .getMinutes()
    .toString()
    .padStart(2, "0")}:${currentDates
    .getSeconds()
    .toString()
    .padStart(2, "0")}`;

  const getTimeSinceCreation = (dateString, mytimers) => {
    // let dateString = rentDetailsData.ads_details.active_on_virtual;

    let parts = dateString.split("T");
    let extractedDate = parts[0] + "T" + parts[1].split(".")[0];
    const convertToTimeZone = (datetime, fromTimeZone, toTimeZone) => {
      return moment
        .tz(datetime, fromTimeZone)
        .tz(toTimeZone)
        .format("YYYY-MM-DD HH:mm:ss");
    };

    const originalDatetime = extractedDate;

    const timezoneString = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const targetTimeZone = timezoneString;

    const convertedDatetime = convertToTimeZone(
      originalDatetime,
      mytimers,
      targetTimeZone
    );

    if (formattedDateTime && convertedDatetime) {
      const secondsDiff = moment
        .duration(moment(formattedDateTime).diff(convertedDatetime))
        .asSeconds();

      if (secondsDiff < 60) {
        return "just now";
      } else if (secondsDiff < 3600) {
        const minutesDiff = Math.floor(secondsDiff / 60);
        return minutesDiff === 1
          ? "1 minute ago"
          : `${minutesDiff} minutes ago`;
      } else if (secondsDiff < 86400) {
        const hoursDiff = Math.floor(secondsDiff / 3600);
        return hoursDiff === 1 ? "1 hour ago" : `${hoursDiff} hours ago`;
      } else if (secondsDiff < 172800) {
        return "Yesterday";
      } else {
        const daysDiff = Math.floor(secondsDiff / 86400);
        return daysDiff === 1 ? "1 day ago" : `${daysDiff} days ago`;
      }
    }
  };

  useEffect(() => {
    if (!latitudes || !longitudes) return;
    fetchJobsData();
    fetchEventsData();
    fetchBabySitterData();
    fetchBuySellData();
    fetchLocalBizData();
    adsOnValidityData();
    recommendedAds();
  // }, [lat, lang, latitudes, longitudes]);
  }, [latitudes, longitudes]);


  useEffect(() => {
    if (!latitudes || !longitudes) return;
    fetchRoomRentData();
  }, [lat, lang, latitudes, longitudes]);

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "grey",
          borderRadius: "20px",
          color: "black",
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          background: "grey",
          borderRadius: "20px",
          color: "black",
        }}
        onClick={onClick}
      />
    );
  }

  const titlebtn = (record) => {
    switch (record.adsType.name) {
      case "Buy & Sell":
        return `/buySellDetails/${record._id}`;
      case "Events":
        return `/eventDetails/${record._id}`;
      case "Rentals":
        return `/rentDetails/${record._id}`;
      case "Babysitters & Nannies":
        return `/babySitterDetails/${record._id}`;
      case "Jobs":
        return `/jobDetails/${record._id}`;
      case "Local Biz & Services":
        return `/localBizDetails/${record._id}`;
      default:
        return "/";
    }
  };
  return (
    <>
      {!latitudes || !longitudes ? (
        <div style={{ marginTop: "20px" }}>
          <h3 style={{ textAlign: "center" }}>
            Please Select Your Location From Above To Access Your Location Ads
          </h3>
          <h3 style={{ textAlign: "center" }}>
            የሚፈልጉትን አካባቢ ማስታወቂያ ለማየት ከላይ ያለዉን "Select Location" የሚለዉን በመጫን
            የሚፈልጉትን አካባቢ ይምረጡ።
          </h3>
        </div>
      ) : (
        <div className="Main-wrapper-section">
          <div className="section">
            {adsOnData && adsOnData.data && adsOnData.data.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">
                  {adsOnData.name} - ዋና ዋና ስብስቦች
                </div>
              </div>
            )}

            {adsOnData && adsOnData.data && adsOnData.data.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                //showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {adsOnData.data.map((record, index) => (
                  <AdsOnCard
                    key={index}
                    myAdsType={record.adsType._id}
                    myAdsTypeName={record.adsType.name}
                    data={record.price_default}
                    _id={record._id}
                    myFavourite={record.is_favorite}
                    title={record.adsInfo.title}
                    location={record.adsInfo.location.location_name}
                    titleColor=""
                    imageSrc={
                      record.adsInfo.image &&
                      record.adsInfo.image.map((img) => img.url)
                    }
                    featured={record.addons_validity.some(
                      (item) =>
                        item.name === "Featured" &&
                        item.active_on <= currentDate &&
                        item.expired_on >= currentDate
                    )}
                    dateType={getTimeSinceCreation(
                      record.active_on_virtual,
                      record.location_timezone
                    )}
                    upcomingLabel={
                      record.addons_validity.some(
                        (addon) =>
                          addon.name === "Upcoming Event" &&
                          addon.active_on <= currentDate &&
                          addon.expired_on >= currentDate
                      )
                        ? "Upcoming Event"
                        : ""
                    }
                    // viewCount={record.viewCount}
                    viewCount={
                      record.viewCount ?? record.view_count ?? record.views ?? 0
                    }
                    urgentLabel={
                      record.addons_validity.some(
                        (addon) =>
                          addon.name === "Urgent" &&
                          addon.active_on <= currentDate &&
                          addon.expired_on >= currentDate
                      )
                        ? "Urgent"
                        : ""
                    }
                  />
                ))}
              </Carousel>
            )}

            {/* Recommended Ads */}
            {recommendData && recommendData && recommendData?.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">
                  Recommended for you - ለእርስዎ የሚመከር
                </div>
              </div>
            )}

            {recommendData && recommendData && recommendData?.length > 0 ? (
              <Carousel
                responsive={responsive}
                ssr
                //showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {recommendData?.map((record, index) => (
                  <AdsOnCard
                    key={index}
                    myAdsType={record.adsType._id}
                    myAdsTypeName={record.adsType.name}
                    data={record.price_default}
                    _id={record._id}
                    myFavourite={record.isFavorite}
                    title={record.adsInfo.title}
                    location={record.adsInfo.location.location_name}
                    titleColor=""
                    imageSrc={
                      record.adsInfo.image &&
                      record.adsInfo.image.map((img) => img.url)
                    }
                    featured={record.addons_validity.some(
                      (item) =>
                        item.name === "Featured" &&
                        item.active_on <= currentDate &&
                        item.expired_on >= currentDate
                    )}
                    dateType={getTimeSinceCreation(
                      record.active_on_virtual,
                      record.location_timezone
                    )}
                    upcomingLabel={
                      record.addons_validity.some(
                        (addon) =>
                          addon.name === "Upcoming Event" &&
                          addon.active_on <= currentDate &&
                          addon.expired_on >= currentDate
                      )
                        ? "Upcoming Event"
                        : ""
                    }
                    viewCount={record.viewCount}
                    urgentLabel={
                      record.addons_validity.some(
                        (addon) =>
                          addon.name === "Urgent" &&
                          addon.active_on <= currentDate &&
                          addon.expired_on >= currentDate
                      )
                        ? "Urgent"
                        : ""
                    }
                  />
                ))}
              </Carousel>
            ) : (
              loader &&
              latitudes !== null &&
              longitudes !== null && (
                <div className="skeleton-loader">
                  <div className="skeleton skeleton-header"></div>
                  <div className="skeleton skeleton-text"></div>
                  <div className="skeleton skeleton-text"></div>
                  <div className="skeleton skeleton-text"></div>
                </div>
              )
            )}

            {/* Urgent Data */}

            {urgentData && urgentData.data && urgentData.data.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">{urgentData.name} - አስቸኳይ</div>
              </div>
            )}

            {urgentData && urgentData.data && urgentData.data.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                // showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {urgentData.data.map((record, index) => (
                  <AdsOnCard
                    key={index}
                    _id={record._id}
                    myFavourite={record.is_favorite}
                    data={record.price_default}
                    myAdsType={record.adsType._id}
                    myAdsTypeName={record.adsType.name}
                    title={record.adsInfo.title}
                    location={record.adsInfo.location.location_name}
                    titleColor=""
                    imageSrc={
                      record.adsInfo.image &&
                      record.adsInfo.image.map((img) => img.url)
                    }
                    viewCount={record.viewCount ?? record.viewCount ?? record.views ?? 0}
                    featured={record.addons_validity.some(
                      (item) =>
                        item.name === "Featured" &&
                        item.active_on <= currentDate &&
                        item.expired_on >= currentDate
                    )}
                    urgentLabel={
                      record.addons_validity.some(
                        (addon) =>
                          addon.name === "Urgent" &&
                          addon.active_on <= currentDate &&
                          addon.expired_on >= currentDate
                      )
                        ? "Urgent"
                        : ""
                    }
                    dateType={getTimeSinceCreation(
                      record.active_on_virtual,
                      record.location_timezone
                    )}
                  />
                ))}
              </Carousel>
            )}

            {upcomingEventData &&
              upcomingEventData.data &&
              upcomingEventData.data.length > 0 && (
                <div className="body-card">
                  <div className="body-card-text">
                    {upcomingEventData.name} - በቅርቡ የሚመጡ ዝግጅቶች
                  </div>
                </div>
              )}

            {upcomingEventData &&
              upcomingEventData.data &&
              upcomingEventData.data.length > 0 && (
                <Carousel
                  responsive={responsive}
                  ssr
                  // showDots={true}
                  infinite={false}
                  containerClass="carousel-container"
                  itemClass="carousel-item-padding-40-px"
                >
                  {upcomingEventData.data.map((record, index) => (
                    //  <Link to={titlebtn(record)} key={index}>
                    <AdsOnCard
                      key={index}
                      _id={record._id}
                      myFavourite={record.is_favorite}
                      data={record.price_default}
                      myAdsType={record.adsType._id}
                      myAdsTypeName={record.adsType.name}
                      title={record.adsInfo.title}
                      location={record.adsInfo.location.location_name}
                      titleColor=""
                      imageSrc={
                        record.adsInfo.image &&
                        record.adsInfo.image.map((img) => img.url)
                      }
                      // featured={record.is_featured}
                      featured={record.addons_validity.some(
                        (item) =>
                          item.name === "Featured" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )}
                      dateType={getTimeSinceCreation(
                        record.active_on_virtual,
                        record.location_timezone
                      )}
                      // titlebtn={titlebtn(record)}
                      upcomingLabel={
                        record.addons_validity.some(
                          (addon) =>
                            addon.name === "Upcoming Event" &&
                            addon.active_on <= currentDate &&
                            addon.expired_on >= currentDate
                        )
                          ? "Upcoming Event"
                          : ""
                      }
                    />
                    //  </Link>
                  ))}
                </Carousel>
              )}

            {/* Price Drop Data */}
            {priceDropData &&
              priceDropData.data &&
              priceDropData.data.length > 0 && (
                <div className="body-card">
                  <div className="body-card-text">
                    {priceDropData.name} - የዋጋ ቅናሽ
                  </div>
                </div>
              )}

            {priceDropData &&
              priceDropData.data &&
              priceDropData.data.length > 0 && (
                <Carousel
                  responsive={responsive}
                  ssr
                  // showDots={true}
                  infinite={false}
                  containerClass="carousel-container"
                  itemClass="carousel-item-padding-40-px"
                >
                  {priceDropData.data.map((record, index) => (
                    //  <Link to={titlebtn(record)} key={index}>
                    <AdsOnCard
                      key={index}
                      _id={record._id}
                      myFavourite={record.is_favorite}
                      data={record.price_default}
                      myAdsType={record.adsType._id}
                      myAdsTypeName={record.adsType.name}
                      title={record.adsInfo.title}
                      location={record.adsInfo.location.location_name}
                      titleColor=""
                      imageSrc={
                        record.adsInfo.image &&
                        record.adsInfo.image.map((img) => img.url)
                      }
                      // featured={record.is_featured}
                      featured={record.addons_validity.some(
                        (item) =>
                          item.name === "Featured" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )}
                      urgentLabel={
                        record.addons_validity.some(
                          (addon) =>
                            addon.name === "Urgent" &&
                            addon.active_on <= currentDate &&
                            addon.expired_on >= currentDate
                        )
                          ? "Urgent"
                          : ""
                      }
                      dateType={getTimeSinceCreation(
                        record.active_on_virtual,
                        record.location_timezone
                      )}
                      // titlebtn={titlebtn(record)}
                    />
                    // </Link>
                  ))}
                </Carousel>
              )}

            {/* {!roomRentData || roomRentData.length === 0 && <Shimmer width={"100%"} height={300} />} */}

            {/* Rooms for Rent data */}
            {roomRentData && roomRentData.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">Rentals - የኪራይ ማስታወቂያዎች</div>
                <div className="view-btn">
                  <i onClick={handleRedirect}>
                    <button type="button" className="btn btn-view">
                      View All
                    </button>
                  </i>
                </div>
              </div>
            )}

            {roomRentData && roomRentData.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                // showDots={true}
                infinite={false}
                  arrows={roomRentData.length > 1} 
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {roomRentData.map((record, index) => (
                  //  <Link to={`/rentDetails/${record._id}`} key={index}>
                  <Card
                    key={index}
                    _id={record._id}
                    title={record.adsInfo.title}
                    adsButton="Price Drop"
                    location={record.adsInfo.location.location_name}
                    shareTitle={"rentDetails"}
                    titleColor=""
                    myFavourite={record.is_favorite}
                    imageSrc={
                      record.adsInfo.image &&
                      record.adsInfo.image.map((img) => img.url)
                    }
                    // featured={record.isfeatured}
                    // featured={record.addons_validity.some(
                    //   (item) =>
                    //     item.name === "Featured" &&
                    //     item.active_on <= currentDate &&
                    //     item.expired_on >= currentDate
                    // )}
                    // featured={rentfeatureStatus[index] ? true : false}
                    featured={rentfeatureStatus[index] === true}
                    dateType={getTimeSinceCreation(
                      record.active_on_virtual,
                      record.location_timezone
                    )}
                    rentAmount={
                      record.adsInfo.rent.is_contact &&
                      record.adsInfo.rent.amount === 0 ? (
                        <p>Please Contact</p>
                      ) : record.adsInfo.rent.negotiable &&
                        record.adsInfo.rent.amount !== 0 ? (
                        <p>
                          {getSymbolFromCurrency(record.adsInfo.rent.currency)}
                          {record.adsInfo.rent.amount}{" "}
                          {record.adsInfo.rent_info || ""} Negotiable
                        </p>
                      ) : record.adsInfo.rent.negotiable ? (
                        <p>Negotiable</p>
                      ) : record.adsInfo.rent.currency &&
                        record.adsInfo.rent.amount !== 0 ? (
                        <p>
                          Please Contact
                          {/* {getSymbolFromCurrency(record.adsInfo.rent.currency)}
                        {record.adsInfo.rent.amount}
                        {record.adsInfo.rent_info || ""} */}
                        </p>
                      ) : null
                    }
                    UrgentLabel={
                      record.addons_validity.some(
                        (item) =>
                          item.name === "Urgent" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )
                        ? "Urgent"
                        : ""
                    }
                    viewCount={record.viewCount}
                  />
                  //  </Link>
                ))}
              </Carousel>
            )}

            {/* Job data */}
            {myJobsData && myJobsData.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">Jobs - የስራ ማስታወቂያዎች</div>
                <div className="view-btn">
                  <i onClick={handleRedirectJobs}>
                    <button type="button" className="btn btn-view">
                      View All
                    </button>
                  </i>
                </div>
              </div>
            )}

            {myJobsData && myJobsData.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                // showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {myJobsData.map((job, index) => (
                  <Jobcard
                    key={index}
                    _id={job._id}
                    title={job.adsInfo.title}
                    shareTitle={"jobDetails"}
                    myFavourite={job.is_favorite}
                    location={job.adsInfo.location.location_name}
                    imageSrc={
                      job.adsInfo.image &&
                      job.adsInfo.image.map((img) => img.url)
                    }
                    // featured={job.is_featured.value}
                    // featured={job.addons_validity.some(
                    //   (item) =>
                    //     item.name === "Featured" &&
                    //     item.active_on <= currentDate &&
                    //     item.expired_on >= currentDate
                    // )}
                    featured={jobFeaturedStatus[index] === true}
                    // featured={jobFeaturedStatus[index] ? true : false}
                    dateType={getTimeSinceCreation(
                      job.active_on_virtual,
                      job.location_timezone
                    )}
                    jobAmount={
                      job.adsInfo.salary.amount ? (
                        <p>
                          {getSymbolFromCurrency(job.adsInfo.salary.currency)}{" "}
                          {job.adsInfo.salary.amount} {job.adsInfo.salary_info}
                        </p>
                      ) : null
                    }
                    eventLabel={
                      job.addons_validity.some(
                        (item) =>
                          item.name === "Upcoming Event" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )
                        ? "Upcoming Event"
                        : job.addons_validity.some(
                            (item) =>
                              item.name === "Urgent" &&
                              item.active_on <= currentDate &&
                              item.expired_on >= currentDate
                          )
                        ? "Urgent"
                        : ""
                    }
                    viewCount={job.viewCount}
                  />
                  //  </Link>
                ))}
              </Carousel>
            )}

            {/* Event data  */}
            {eventsData && eventsData.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">Events - የተለያዩ ዝግጅቶች</div>
                <div className="view-btn">
                  <i onClick={handleRedirectEvents}>
                    <button type="button" className="btn btn-view">
                      View All
                    </button>
                  </i>
                </div>
              </div>
            )}

            {eventsData && eventsData.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                // showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {eventsData.map((e, index) => (
                  //  <Link to={`/eventDetails/${e._id}`} style={{ color: "#F17D3A" }}>
                  <Eventlistcard
                    key={index}
                    _id={e._id}
                    title={e.adsInfo.title}
                    shareTitle={"eventDetails"}
                    myFavourite={e.is_favorite}
                    location={e.adsInfo.location.location_name}
                    titleColor=""
                    imageSrc={
                      e.adsInfo.image && e.adsInfo.image.map((img) => img.url)
                    }
                    viewCount={e.viewCount}
                    // featured={e.isfeatured}
                    // featured={e.addons_validity.some(
                    //   (item) =>
                    //     item.name === "Featured" &&
                    //     item.active_on <= currentDate &&
                    //     item.expired_on >= currentDate
                    // )}
                    featured={eventFeaturedStatus[index] === true}
                    // featured={eventFeaturedStatus[index] ? true : false}
                    dateType={getTimeSinceCreation(
                      e.active_on_virtual,
                      e.location_timezone
                    )}
                    // eventAmount={
                    //   <p>
                    //     {e.adsInfo.ticket_price.regular_ticket_price === 0 ? "" :
                    //     (e.adsInfo.ticket_price.regular_ticket_price ?? 'undefined') ===
                    //     'undefined'
                    //       ? "Free"
                    //       : `${getSymbolFromCurrency(
                    //           e.adsInfo.ticket_price.currency
                    //         )}${e.adsInfo.ticket_price.regular_ticket_price}`}
                    //   </p>
                    // }
                    eventAmount={
  <p>
    {!e.adsInfo.ticket_price ? "Free" :
    e.adsInfo.ticket_price.regular_ticket_price === 0 ? "" :
    (e.adsInfo.ticket_price.regular_ticket_price ?? 'undefined') ===
    'undefined'
      ? "Free"
      : `${getSymbolFromCurrency(
          e.adsInfo.ticket_price.currency
        )}${e.adsInfo.ticket_price.regular_ticket_price}`}
  </p>
}
                    eventLabel={
                      e.addons_validity.some(
                        (item) =>
                          item.name === "Upcoming Event" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )
                        ? "Upcoming Event"
                        : e.addons_validity.some(
                            (item) =>
                              item.name === "Urgent" &&
                              item.active_on <= currentDate &&
                              item.expired_on >= currentDate
                          )
                        ? "Urgent"
                        : ""
                    }
                  />
                  //  </Link>
                ))}
              </Carousel>
            )}

            {/* Babysitters & Nannies Data */}
            {babySitterData && babySitterData.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">
                  Babysitters & Nannies - የሞግዚት ማስታወቂያዎች{" "}
                </div>
                <div className="view-btn">
                  <i onClick={handleRedirectBabySitter}>
                    <button type="button" className="btn btn-view">
                      View All
                    </button>
                  </i>
                </div>
              </div>
            )}

            {babySitterData && babySitterData.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                // showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {babySitterData.map((baby, index) => (
                  //  <Link to={`/babySitterDetails/${baby._id}`} style={{ color: "#F17D3A" }}>
                  <Babysittercard
                    key={index}
                    _id={baby._id}
                    title={baby.adsInfo.title}
                    shareTitle={"babySitterDetails"}
                    location={baby.adsInfo.location.location_name}
                    imageSrc={
                      baby.adsInfo.image &&
                      baby.adsInfo.image.map((img) => img.url)
                    }
                    duration=""
                    titleColor=""
                    myFavourite={baby.is_favorite}
                    // featured={baby.addons_validity.some(
                    //   (item) =>
                    //     item.name === "Featured" &&
                    //     item.active_on <= currentDate &&
                    //     item.expired_on >= currentDate
                    // )}
                    featured={babyFeaturedStatus[index] === true}
                    dateType={getTimeSinceCreation(
                      baby.active_on_virtual,
                      baby.location_timezone
                    )}
                    babyAmount={
                      baby.adsInfo.expected_salary_amount &&
                      baby.adsInfo.expected_salary_amount.is_contact ? (
                        <p>Please Contact</p>
                      ) : baby.adsInfo.expected_salary_amount ? (
                        baby.adsInfo.expected_salary_amount.amount === 0 ? (
                          <p>Please Contact</p>
                        ) : (
                          <p>
                            {getSymbolFromCurrency(
                              baby.adsInfo.expected_salary_amount.currency
                            )}
                            {baby.adsInfo.expected_salary_amount.amount}
                            {baby.adsInfo.expected_salary_rate}
                          </p>
                        )
                      ) : null
                    }
                    eventLabel={
                      baby.addons_validity.some(
                        (item) =>
                          item.name === "Upcoming Event" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )
                        ? "Upcoming Event"
                        : baby.addons_validity.some(
                            (item) =>
                              item.name === "Urgent" &&
                              item.active_on <= currentDate &&
                              item.expired_on >= currentDate
                          )
                        ? "Urgent"
                        : ""
                    }
                    viewCount={baby.viewCount}
                  />
                  // </Link>
                ))}
              </Carousel>
            )}

            {/* Buy & Sell Data */}
            {buySellData && buySellData.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">Buy & Sell - ግዢና ሽያጮች</div>
                <div className="view-btn">
                  <i onClick={handleRedirectBuySell}>
                    <button type="button" className="btn btn-view">
                      View All
                    </button>
                  </i>
                </div>
              </div>
            )}

            {buySellData && buySellData.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {buySellData.map((buy, index) => (
                  //  <Link to={`/buySellDetails/${buy._id}`} style={{ color: "#F17D3A" }}>
                  <Buysellcard
                    key={index}
                    _id={buy._id}
                    title={buy.adsInfo.title}
                    location={buy.adsInfo.location.location_name}
                    imageSrc={
                      buy.adsInfo.image &&
                      buy.adsInfo.image.map((img) => img.url)
                    }
                    // featured={buy.addons_validity.some(
                    //   (item) =>
                    //     item.name === "Featured" &&
                    //     item.active_on <= currentDate &&
                    //     item.expired_on >= currentDate
                    // )}
                    featured={buySellFeaturedStatus[index] === true}
                    eventLabel={
                      buy.addons_validity.some(
                        (item) =>
                          item.name === "Urgent" &&
                          item.active_on <= currentDate &&
                          item.expired_on >= currentDate
                      )
                        ? "Urgent"
                        : ""
                    }
                    viewCount={buy.viewCount}
                    // featured={buySellFeaturedStatus[index] ? true : false}
                    myFavourite={buy.is_favorite}
                    shareTitle={"buySellDetails"}
                    dateType={getTimeSinceCreation(
                      buy.active_on_virtual,
                      buy.location_timezone
                    )}
                    localbtn="Local"
                    buyAmount={
                      buy.adsInfo.price.is_contact ? (
                        <p>Please Contact</p>
                      ) : (
                        <div style={{ display: "flex" }}>
                          {buy.price_drop && buy.adsInfo.price.amount > 0 ? (
                            <>
                              <p
                                style={{
                                  textDecoration: "line-through",
                                  color: "grey",
                                }}
                              >
                                {getSymbolFromCurrency(
                                  buy.adsInfo.price.currency
                                )}
                                {buy.adsInfo.price.amount}
                              </p>
                              <p>
                                {getSymbolFromCurrency(
                                  buy.adsInfo.price.currency
                                )}
                                {buy.price_drop}
                              </p>
                              {buy.adsInfo.price.negotiable ? (
                                <p>Negotiable</p>
                              ) : null}
                            </>
                          ) : (
                            <>
                              {buy.adsInfo.price.amount === 0 ? (
                                <p>Free</p>
                              ) : (
                                <>
                                  <p>
                                    {getSymbolFromCurrency(
                                      buy.adsInfo.price.currency
                                    )}
                                    {buy.adsInfo.price.amount}
                                  </p>
                                  {buy.adsInfo.price.negotiable ? (
                                    <p>Negotiable</p>
                                  ) : null}
                                </>
                              )}
                            </>
                          )}
                        </div>
                      )
                    }
                  />
                  // </Link>
                ))}
              </Carousel>
            )}

            {/* Local Biz & Services Data */}
            {localBizData && localBizData.length > 0 && (
              <div className="body-card">
                <div className="body-card-text">
                  Local Biz & Services - ንግድና አገልግሎቶች
                </div>
                <div className="view-btn">
                  <i onClick={handleRedirectLocalBiz}>
                    <button type="button" className="btn btn-view">
                      View All
                    </button>
                  </i>
                </div>
              </div>
            )}

            {localBizData && localBizData.length > 0 && (
              <Carousel
                responsive={responsive}
                ssr
                // showDots={true}
                infinite={false}
                containerClass="carousel-container"
                itemClass="carousel-item-padding-40-px"
              >
                {localBizData.map((biz, index) => (
                  <Link
                    to={`/localBizDetails/${biz._id}`}
                    style={{ color: "#F17D3A" }}
                  >
                    <LocalBizcard
                      key={index}
                      _id={biz._id}
                      shareTitle={"localBizDetails"}
                      title={biz.adsInfo.title}
                      location={biz.adsInfo.location.location_name}
                      myFavourite={biz.is_favorite}
                      // featured={biz.addons_validity.some(
                      //   (item) =>
                      //     item.name === "Featured" &&
                      //     item.active_on <= currentDate &&
                      //     item.expired_on >= currentDate
                      // )}
                      featured={bizFeaturedStatus[index] === true}
                      imageSrc={
                        biz.adsInfo.image &&
                        biz.adsInfo.image.map((img) => img.url)
                      }
                      localbtn="Local"
                      dateType={getTimeSinceCreation(
                        biz.active_on_virtual,
                        biz.location_timezone
                      )}
                      eventLabel={
                        biz.addons_validity.some(
                          (item) =>
                            item.name === "Urgent" &&
                            item.active_on <= currentDate &&
                            item.expired_on >= currentDate
                        )
                          ? "Urgent"
                          : ""
                      }
                      viewCount={biz.viewCount}
                    />
                  </Link>
                ))}
              </Carousel>
            )}
          </div>
        </div>
      )}
    </>
  );
}
